import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import AppLayout from './layouts/AppLayout';
import HomePage from './pages/HomePage';
import UploadDocumentsPage from './pages/UploadDocumentsPage';
import ManualAnalysisPage from './pages/ManualAnalysisPage';
import AnalysisPage from './pages/AnalysisPage';
import DemoTutorial from './components/DemoTutorial';
import { DemoProvider } from './context/DemoContext';
import { VersionProvider } from './context/VersionContext';
import { ThemeProvider } from './context/ThemeContext';
import { TutorialProvider } from './context/TutorialContext';
import { Header, AnchorNavigation } from '@cloudscape-design/components';

// Authentication
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AuthCallback } from './auth/AuthCallback';

// UIv2 pages
import ProcessPage from './pages/v2/ProcessPage';
import ReviewPage from './pages/v2/ReviewPage';
import ReportPage from './pages/v2/ReportPage';
import ErrorBoundary from './components/ErrorBoundary';

// Deep Dive pages
import StrandsAgentsPage from './pages/deep-dive/StrandsAgentsPage';
import ArchitecturePage from './pages/deep-dive/ArchitecturePage';
import DeploymentPage from './pages/deep-dive/DeploymentPage';
import CodePage from './pages/deep-dive/CodePage';
import ModelStrategyPage from './pages/deep-dive/ModelStrategyPage';
import ObservabilityPage from './pages/deep-dive/ObservabilityPage';
import BuildVsBuyPage from './pages/deep-dive/BuildVsBuyPage';

// Admin pages (hidden — navigate directly)
import AnalyticsDashboard from './pages/admin/AnalyticsDashboard';

function App() {
  const [showTutorial, setShowTutorial] = useState(false);
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith('/admin'); // reserved for future use

  return (
    <AuthProvider>
      <ProtectedRoute>
        <VersionProvider>
          <ThemeProvider>
          <DemoProvider>
            <TutorialProvider>
            <AppLayout onShowTutorial={() => setShowTutorial(true)}>
              {showTutorial && <DemoTutorial onDismiss={() => setShowTutorial(false)} />}
              <Routes>
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/upload" element={<UploadDocumentsPage />} />
                <Route path="/manual-analysis" element={<ManualAnalysisPage />} />
                <Route path="/analysis" element={<AnalysisPage />} />
                <Route path="/v2/process" element={<ErrorBoundary><ProcessPage /></ErrorBoundary>} />
                <Route path="/v2/review" element={<ErrorBoundary><ReviewPage /></ErrorBoundary>} />
                <Route path="/v2/report/:sessionId" element={<ErrorBoundary><ReportPage /></ErrorBoundary>} />
                <Route path="/v2/report" element={<ErrorBoundary><ReportPage /></ErrorBoundary>} />
                <Route path="/deep-dive/strands-agents" element={<StrandsAgentsPage />} />
                <Route path="/deep-dive/architecture" element={<ArchitecturePage />} />
                <Route path="/deep-dive/deployment" element={<DeploymentPage />} />
                <Route path="/deep-dive/observability" element={<ObservabilityPage />} />
                <Route path="/deep-dive/code" element={<CodePage />} />
                <Route path="/deep-dive/model-strategy" element={<ModelStrategyPage />} />
                <Route path="/deep-dive/build-vs-buy" element={<BuildVsBuyPage />} />
                {/* Admin — inside AppLayout so no remount flash */}
                <Route path="/admin/analytics" element={<ErrorBoundary><AnalyticsDashboard /></ErrorBoundary>} />
              </Routes>
            </AppLayout>
            </TutorialProvider>
        </DemoProvider>
      </ThemeProvider>
      </VersionProvider>
    </ProtectedRoute>
  </AuthProvider>
  );
}

export default App;
